import { Config } from '../../config'

export const netaConfig: Config = {
  partner: 'neta',
  catalog: 'partner',
  displayName: 'Neta Scientific',
  accentColor: '#00afaa',
  host: 'seating.netascientific.com',
}

